<template>
  <div>
    <header>
      <section>
        <div class="title-container">
          <a :href="getWDTURL('/recruit/')">
            <div class="title-wrapper">
              <p class="logo-wrapper">
                <img src="@/assets/lp/logo.png" alt="ロゴ">
              </p>
              <p class="logo-title"><img src="@/assets/lp/logo_blue.svg" alt="タイトル"></p>
            </div>
          </a>
          <p class="additional-title">企業のリアルがすぐわかる転職サイト</p>
        </div>
        <nav class="link-nav">
          <ul>
              <li class="profile-button" @click="menuFlg = !menuFlg" v-if="isUser">
                  <img class="header-img-icon" :src="user.profileIcon"/>
              <li>
              <li class="pc-menu" v-if="!isUser">
                <div class="top-button-container">
                  <p class="search-link-wrapper">
                    <a :href="getOwnURL('#')">
                      <button class="register-btn"><font-awesome-icon class="icon-search" :icon="['fas', 'search']" />求人を探す</button>
                    </a>
                  </p>
                  <p>
                    <a :href="getOwnURL('/create_user')">
                      <button class="register-btn"><font-awesome-icon class="icon-pen" :icon="['fas', 'pen-alt']" />無料会員登録</button>
                    </a>
                  </p>
                </div>
                <p class="recruit-company-link-wrapper" v-if="!isUser">
                  <a :href="getOwnURL('')">
                    <p class="company-link">求人掲載希望の企業様はこちら</p>
                  </a>
                </p>
              </li>
              <li id="login_link" class="pc-menu" v-if="!isUser">
                <a :href="getOwnURL('/login')">
                  <button class="login-btn">
                    <font-awesome-icon class="icon-building" :icon="['far', 'building']" />
                    <p>ログイン</p>
                  </button>
                </a>
              </li>
              <li v-if="!isUser" class="menu-bars-wrapper">
                  <div @click="menuFlg = !menuFlg">
                      <font-awesome-icon class="menu-bars" :icon="['fas', 'bars']" />
                  </div>
              </li>
          </ul>
        </nav>
      </section>
    </header>
    <!-- モーダルメニュー -->
    <div class="menu" v-if="menuFlg === true">
      <div v-if="!isUser">
        <div class="menu-title-wrapper">
            <div class="menu-logo-wrapper">
                <img src="@/assets/lp/logo.png" alt="ロゴ">
            </div>
            <p class="menu-logo-title"><img src="@/assets/lp/logo_blue.svg" alt="HRモンスタータイトル"></p>
        </div>
        <ul>
            <li>
                <a href="/login">
                    <p class="item-login"><font-awesome-icon class="icon-building-responsive" :icon="['far', 'building']" />ログイン</p>
                </a>
            </li>
            <li>
                <a href="#">
                    <p class="item-search"><font-awesome-icon class="icon-search" :icon="['fas', 'search']" />求人を探す</p>
                </a>
            </li>
            <li>
                <a href="/create_user">
                    <p class="item-register"><font-awesome-icon class="icon-pen" :icon="['fas', 'pen-alt']" />無料会員登録</p>
                </a>
            </li>
            <li>
                <a href="/">
                    <p class="item-client-link">求人掲載希望の企業様はこちら</p>
                </a>
            </li>
        </ul>
      </div>
      <div v-if="isUser">
        <div class="user-info">
          <div class="profile-button" @click="menuFlg = !menuFlg">
            <img class="img-icon" :src="user.profileIcon"/>
          </div>
          <div class="name-and-email">
            <p class="name">{{user.username}}</p>
            <p class="email">{{user.email}}</p>
          </div>
        </div>
        <ul class="user-menu">
          <li><a href="/recruits/mypage/"><font-awesome-icon :icon="['fas', 'user-circle']" />プロフィール編集</a></li>
          <li><a href="/recruits/status/follow_company"><font-awesome-icon :icon="['far', 'star']" />フォロー中の企業</a></li>
          <li><a href="/recruits/status/company"><font-awesome-icon :icon="['fas', 'building']" />応募・会話した企業一覧</a></li>
          <li><a href="/recruits/favoriteNovel"><font-awesome-icon :icon="['fas', 'book-reader']" />保存した求人ノベル</a></li>
          <li><div class="logout-btn" @click="logout()"><font-awesome-icon :icon="['fas', 'sign-out-alt']" />ログアウト</div></li>
        </ul>
      </div>
    </div>
    <!-- モーダルの背景 -->
    <div v-if="menuFlg" @click="menuFlg = false" id="modal_cover" class="modal-cover"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'RecruitNav',
  componentName: 'RecruitNav',
  computed: {
    ...mapState('auth', ['user', 'isUser', 'token']),
    ...mapState('directtalk', ['chatLogs', 'chatLogs2', 'chatLogs3', 'readLogs', 'messagePages', 'isOCRReading', 'ocrData']),
  },
  data() {
    return {
      showaMax: 64,
      heiseiMax: 31,
      reiwaMax: 99,
      fileLeft: null,
      fileRight: null,
      ocrResumeRows: [],
      imageUploadStep: 1,
      imageUploadStepEdit: 1,
      rirekisyoStep: 0,
      rirekisyoStepEdit: 0,
      isShowModal: false,
      isShowModalEdit: false,
      isShowMenu: false,
      searchWord: '',
      testjudge: false,
      cName: '',
      shikakuData: {
        'shikaku_nen': null,
        'shikaku_tsuki': null,
        'shikaku': null
      },
      keirekiData: {
        'reki_nen': null,
        'reki_tsuki': null,
        'reki': null
      },
      shikakuTable: [],
      keirekiTable: [],
      keirekiTable2: [],
      menuFlg: false
    }
  },
  created () {
    console.debug('*** Start *** created')
    // コンテンツの取得
    this.$store.dispatch('employmentPage/getContentsListPublic', 1)
    this.$store.dispatch('employmentPage/getContentsApply')
    console.debug('*** End *** created')
  },
  watch:{
    fileLeft () {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.ocrResumeRows.push({
          filename: e.target.fileName,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileLeft)
    },
    fileRight () {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.ocrResumeRows.push({
          filename: e.target.fileName,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileRight)
    },
    'user.profileSeeker_info'() {
      this.$store.dispatch('directtalk/getLastMessage', {data: this.user.profileSeeker_info, name: 'seeker', pages: this.messagePages})
      // this.$store.dispatch('directtalk/getReadLastMessage', {data: this.user.profileSeeker_info, name: 'seeker', pages: this.messagePages})
    }
  },
  methods: {
    getOwnURL (path) {
      return process.env.OWN_ENDPOINT + path
    },
    getWDTURL (path) {
      return process.env.WDT_ENDPOINT + path
    },
    initTable () {
      this.shikakuTable = []
      this.keirekiTable = []
      this.keirekiTable2 = []
    },
    resumeCreate () {
      this.makeResume()
      this.$store.dispatch("directtalk/createResume", { data: this.inputs })
    },
    registerOCR () {
      this.$store.dispatch('directtalk/uploadOCR',this.ocrResumeRows)
      this.imageUploadStep++
    },
    search () {
      console.debug('*** Start *** search')
      this.$store.dispatch('employmentPage/getContentsSearch', this.searchWord)
        .then(() => {
          this.$router.push('/recruit/')
        })
      console.debug('*** End *** search')
    },
    logout () {
      console.debug('*** Start *** logout')
      this.$store.dispatch('auth/logout')
        .then(() => this.logoutBar())
      console.debug('*** End *** logout')
    },
    logoutBar () {
      console.debug('*** Start *** logoutBar')
      this.$buefy.snackbar.open({
        message: 'ログアウトしました。',
        type: 'is-primary',
        position: 'is-top'
      })
      document.location.href = '/recruit/'
      console.debug('*** End *** logoutBar')
    },
    getNewMessage(log){
      var testname = ""
      for (var i = this.chatLogs2.length - 1; i >= 0; i--) {
        for (var j = log.length -1; j >=0; j--) {
          if (log[j].testid == this.chatLogs2[i].testid) {
            if (log[j].createC > this.chatLogs2[i].createC) {
              testname += "既読"
            }
            else {
              testname += "未読"
            }
          }
        }
      }
      // return testname
      if (testname.match(/未読/)){
        this.testjudge = true;
      }
      return this.testjudge
    },
    getcName(log){
      var count = 0
      for (var i = log.length - 1; i >= 0; i--) {
        if(count < log[i].createC){
          count = log[i].createC
        }
      }
      for (var j = log.length - 1; j >= 0; j--) {
        if(count == log[j].createC){
          this.cName = log[j].testid
        }
      }
      return this.cName
    },
    makeResume () {
      var keireki = []
      var shikaku = []
      for (let i in this.ocrData.data[0].reki_nen) {
        let pushData = {}
        if (this.ocrData.data[0].reki_nen[i].length > 0 && this.ocrData.data[0].reki_tsuki[i].length > 0 && this.ocrData.data[0].reki[i].length > 0) {
          pushData['reki_nen']   = this.ocrData.data[0].reki_nen[i]
          pushData['reki_tsuki'] = this.ocrData.data[0].reki_tsuki[i]
          pushData['reki']       = this.ocrData.data[0].reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrData.data[1].reki_nen) {
        let pushData = {}
        if (this.ocrData.data[1].reki_nen[i].length > 0 && this.ocrData.data[1].reki_tsuki[i].length > 0 && this.ocrData.data[1].reki[i].length > 0) {
          pushData['reki_nen']   = this.ocrData.data[1].reki_nen[i]
          pushData['reki_tsuki'] = this.ocrData.data[1].reki_tsuki[i]
          pushData['reki']       = this.ocrData.data[1].reki[i]
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable) {
        let pushData = {}
        if (this.keirekiTable[i].reki_nen && this.keirekiTable[i].reki_tsuki && this.keirekiTable[i].reki) {
          pushData['reki_nen']   = this.keirekiTable[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable[i].reki_tsuki
          pushData['reki']       = this.keirekiTable[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.keirekiTable2) {
        let pushData = {}
        if (this.keirekiTable2[i].reki_nen && this.keirekiTable2[i].reki_tsuki && this.keirekiTable2[i].reki) {
          pushData['reki_nen']   = this.keirekiTable2[i].reki_nen
          pushData['reki_tsuki'] = this.keirekiTable2[i].reki_tsuki
          pushData['reki']       = this.keirekiTable2[i].reki
          keireki.push(pushData)
        }
      }
      for (let i in this.ocrData.data[1].shikaku_nen) {
        let pushData = {}
        if (this.ocrData.data[1].shikaku_nen[i].length > 0 && this.ocrData.data[1].shikaku_tsuki[i].length > 0 && this.ocrData.data[1].shikaku[i].length > 0) {
          pushData['shikaku_nen']   = this.ocrData.data[1].shikaku_nen[i]
          pushData['shikaku_tsuki'] = this.ocrData.data[1].shikaku_tsuki[i]
          pushData['shikaku']       = this.ocrData.data[1].shikaku[i]
          shikaku.push(pushData)
        }
      }
      for (let i in this.shikakuTable) {
        let pushData = {}
        if (this.shikakuTable[i].shikaku_nen && this.shikakuTable[i].shikaku_tsuki && this.shikakuTable[i].shikaku) {
          pushData['shikaku_nen']   = this.shikakuTable[i].shikaku_nen
          pushData['shikaku_tsuki'] = this.shikakuTable[i].shikaku_tsuki
          pushData['shikaku']       = this.shikakuTable[i].shikaku
          shikaku.push(pushData)
        }
      }
      this.inputs.name                 = this.ocrData.data[0].name[0]
      this.inputs.name_phonetic        = this.ocrData.data[0].name_furigana[0]
      this.inputs.sex                  = this.ocrData.data[0].sex[0].indexOf("男") >= 0 ? '1' : this.ocrData.data[0].sex[0].indexOf("女") >= 0 ? '2' : '0' 
      this.inputs.birth_row            = this.ocrData.data[0].birthday[0]
      this.inputs.address              = this.ocrData.data[0].addr[0]
      this.inputs.address_phonetic     = this.ocrData.data[0].addr_furigana[0]
      this.inputs.tel                  = this.ocrData.data[0].tel[0]
      this.inputs.mail                 = this.ocrData.data[0].email[0]
      this.inputs.motive               = this.ocrData.data[1].shibo_doki[0]
      this.inputs.commute_hour         = this.ocrData.data[1].tsukin_jikan[0].replace('約', '').split('時間')[0]
      this.inputs.commute_minute       = this.ocrData.data[1].tsukin_jikan[0].replace('約', '').split('時間')[1]
      this.inputs.dependent            = this.ocrData.data[1].fuyo_kazoku[0]
      this.inputs.spouse               = this.ocrData.data[1].haigusha_umu[0]
      this.inputs.duty                 = this.ocrData.data[1].haigusha_fuyo_gimu[0]
      this.inputs.wish                 = this.ocrData.data[1].kibo[0]
      this.inputs.academic_year1       = keireki[0]  == undefined ? '' : keireki[0].reki_nen
      this.inputs.academic_month1      = keireki[0]  == undefined ? '' : keireki[0].reki_tsuki
      this.inputs.academic_body1       = keireki[0]  == undefined ? '' : keireki[0].reki
      this.inputs.academic_year2       = keireki[1]  == undefined ? '' : keireki[1].reki_nen
      this.inputs.academic_month2      = keireki[1]  == undefined ? '' : keireki[1].reki_tsuki
      this.inputs.academic_body2       = keireki[1]  == undefined ? '' : keireki[1].reki
      this.inputs.academic_year3       = keireki[2]  == undefined ? '' : keireki[2].reki_nen
      this.inputs.academic_month3      = keireki[2]  == undefined ? '' : keireki[2].reki_tsuki
      this.inputs.academic_body3       = keireki[2]  == undefined ? '' : keireki[2].reki
      this.inputs.academic_year4       = keireki[3]  == undefined ? '' : keireki[3].reki_nen
      this.inputs.academic_month4      = keireki[3]  == undefined ? '' : keireki[3].reki_tsuki
      this.inputs.academic_body4       = keireki[3]  == undefined ? '' : keireki[3].reki
      this.inputs.academic_year5       = keireki[4]  == undefined ? '' : keireki[4].reki_nen
      this.inputs.academic_month5      = keireki[4]  == undefined ? '' : keireki[4].reki_tsuki
      this.inputs.academic_body5       = keireki[4]  == undefined ? '' : keireki[4].reki
      this.inputs.academic_year6       = keireki[5]  == undefined ? '' : keireki[5].reki_nen
      this.inputs.academic_month6      = keireki[5]  == undefined ? '' : keireki[5].reki_tsuki
      this.inputs.academic_body6       = keireki[5]  == undefined ? '' : keireki[5].reki
      this.inputs.academic_year7       = keireki[6]  == undefined ? '' : keireki[6].reki_nen
      this.inputs.academic_month7      = keireki[6]  == undefined ? '' : keireki[6].reki_tsuki
      this.inputs.academic_body7       = keireki[6]  == undefined ? '' : keireki[6].reki
      this.inputs.academic_year8       = keireki[7]  == undefined ? '' : keireki[7].reki_nen  
      this.inputs.academic_month8      = keireki[7]  == undefined ? '' : keireki[7].reki_tsuki
      this.inputs.academic_body8       = keireki[7]  == undefined ? '' : keireki[7].reki
      this.inputs.career_year1         = keireki[8]  == undefined ? '' : keireki[8].reki_nen  
      this.inputs.career_month1        = keireki[8]  == undefined ? '' : keireki[8].reki_tsuki
      this.inputs.career_body1         = keireki[8]  == undefined ? '' : keireki[8].reki
      this.inputs.career_year2         = keireki[9]  == undefined ? '' : keireki[9].reki_nen  
      this.inputs.career_month2        = keireki[9]  == undefined ? '' : keireki[9].reki_tsuki
      this.inputs.career_body2         = keireki[9]  == undefined ? '' : keireki[9].reki
      this.inputs.career_year3         = keireki[10] == undefined ? '' : keireki[10].reki_nen  
      this.inputs.career_month3        = keireki[10] == undefined ? '' : keireki[10].reki_tsuki
      this.inputs.career_body3         = keireki[10] == undefined ? '' : keireki[10].reki
      this.inputs.career_year4         = keireki[11] == undefined ? '' : keireki[11].reki_nen  
      this.inputs.career_month4        = keireki[11] == undefined ? '' : keireki[11].reki_tsuki
      this.inputs.career_body4         = keireki[11] == undefined ? '' : keireki[11].reki
      this.inputs.career_year5         = keireki[12] == undefined ? '' : keireki[12].reki_nen  
      this.inputs.career_month5        = keireki[12] == undefined ? '' : keireki[12].reki_tsuki
      this.inputs.career_body5         = keireki[12] == undefined ? '' : keireki[12].reki
      this.inputs.career_year6         = keireki[13] == undefined ? '' : keireki[13].reki_nen  
      this.inputs.career_month6        = keireki[13] == undefined ? '' : keireki[13].reki_tsuki
      this.inputs.career_body6         = keireki[13] == undefined ? '' : keireki[13].reki
      this.inputs.career_year7         = keireki[14] == undefined ? '' : keireki[14].reki_nen  
      this.inputs.career_month7        = keireki[14] == undefined ? '' : keireki[14].reki_tsuki
      this.inputs.career_body7         = keireki[14] == undefined ? '' : keireki[14].reki
      this.inputs.career_year8         = keireki[15] == undefined ? '' : keireki[15].reki_nen  
      this.inputs.career_month8        = keireki[15] == undefined ? '' : keireki[15].reki_tsuki
      this.inputs.career_body8         = keireki[15] == undefined ? '' : keireki[15].reki
      this.inputs.career_year9         = keireki[16] == undefined ? '' : keireki[16].reki_nen  
      this.inputs.career_month9        = keireki[16] == undefined ? '' : keireki[16].reki_tsuki
      this.inputs.career_body9         = keireki[16] == undefined ? '' : keireki[16].reki
      this.inputs.career_year10        = keireki[17] == undefined ? '' : keireki[17].reki_nen  
      this.inputs.career_month10       = keireki[17] == undefined ? '' : keireki[17].reki_tsuki
      this.inputs.career_body10        = keireki[17] == undefined ? '' : keireki[17].reki
      this.inputs.career_year11        = keireki[18] == undefined ? '' : keireki[18].reki_nen  
      this.inputs.career_month11       = keireki[18] == undefined ? '' : keireki[18].reki_tsuki
      this.inputs.career_body11        = keireki[18] == undefined ? '' : keireki[18].reki
      this.inputs.career_year12        = keireki[19] == undefined ? '' : keireki[19].reki_nen  
      this.inputs.career_month12       = keireki[19] == undefined ? '' : keireki[19].reki_tsuki
      this.inputs.career_body12        = keireki[19] == undefined ? '' : keireki[19].reki
      this.inputs.career_year13        = keireki[20] == undefined ? '' : keireki[20].reki_nen  
      this.inputs.career_month13       = keireki[20] == undefined ? '' : keireki[20].reki_tsuki
      this.inputs.career_body13        = keireki[20] == undefined ? '' : keireki[20].reki
      this.inputs.career_year14        = keireki[21] == undefined ? '' : keireki[21].reki_nen  
      this.inputs.career_month14       = keireki[21] == undefined ? '' : keireki[21].reki_tsuki
      this.inputs.career_body14        = keireki[21] == undefined ? '' : keireki[21].reki
      this.inputs.career_year15        = keireki[22] == undefined ? '' : keireki[22].reki_nen  
      this.inputs.career_month15       = keireki[22] == undefined ? '' : keireki[22].reki_tsuki
      this.inputs.career_body15        = keireki[22] == undefined ? '' : keireki[22].reki
      this.inputs.career_year16        = keireki[23] == undefined ? '' : keireki[23].reki_nen  
      this.inputs.career_month16       = keireki[23] == undefined ? '' : keireki[23].reki_tsuki
      this.inputs.career_body16        = keireki[23] == undefined ? '' : keireki[23].reki
      this.inputs.career_year17        = keireki[24] == undefined ? '' : keireki[24].reki_nen  
      this.inputs.career_month17       = keireki[24] == undefined ? '' : keireki[24].reki_tsuki
      this.inputs.career_body17        = keireki[24] == undefined ? '' : keireki[24].reki
      this.inputs.career_year18        = keireki[25] == undefined ? '' : keireki[25].reki_nen  
      this.inputs.career_month18       = keireki[25] == undefined ? '' : keireki[25].reki_tsuki
      this.inputs.career_body18        = keireki[25] == undefined ? '' : keireki[25].reki
      this.inputs.qualification_year1  = shikaku[0]  == undefined ? '' : shikaku[0].reki_nen
      this.inputs.qualification_month1 = shikaku[0]  == undefined ? '' : shikaku[0].reki_tsuki
      this.inputs.qualification_body1  = shikaku[0]  == undefined ? '' : shikaku[0].reki      
      this.inputs.qualification_year2  = shikaku[1]  == undefined ? '' : shikaku[1].reki_nen
      this.inputs.qualification_month2 = shikaku[1]  == undefined ? '' : shikaku[1].reki_tsuki
      this.inputs.qualification_body2  = shikaku[1]  == undefined ? '' : shikaku[1].reki      
      this.inputs.qualification_year3  = shikaku[2]  == undefined ? '' : shikaku[2].reki_nen
      this.inputs.qualification_month3 = shikaku[2]  == undefined ? '' : shikaku[2].reki_tsuki
      this.inputs.qualification_body3  = shikaku[2]  == undefined ? '' : shikaku[2].reki      
      this.inputs.qualification_year4  = shikaku[3]  == undefined ? '' : shikaku[3].reki_nen
      this.inputs.qualification_month4 = shikaku[3]  == undefined ? '' : shikaku[3].reki_tsuki
      this.inputs.qualification_body4  = shikaku[3]  == undefined ? '' : shikaku[3].reki      
      this.inputs.qualification_year5  = shikaku[4]  == undefined ? '' : shikaku[4].reki_nen
      this.inputs.qualification_month5 = shikaku[4]  == undefined ? '' : shikaku[4].reki_tsuki
      this.inputs.qualification_body5  = shikaku[4]  == undefined ? '' : shikaku[4].reki      
      this.inputs.qualification_year6  = shikaku[5]  == undefined ? '' : shikaku[5].reki_nen
      this.inputs.qualification_month6 = shikaku[5]  == undefined ? '' : shikaku[5].reki_tsuki
      this.inputs.qualification_body6  = shikaku[5]  == undefined ? '' : shikaku[5].reki      
      this.inputs.qualification_year7  = shikaku[6]  == undefined ? '' : shikaku[6].reki_nen
      this.inputs.qualification_month7 = shikaku[6]  == undefined ? '' : shikaku[6].reki_tsuki
      this.inputs.qualification_body7  = shikaku[6]  == undefined ? '' : shikaku[6].reki      
      this.inputs.qualification_year8  = shikaku[7]  == undefined ? '' : shikaku[7].reki_nen
      this.inputs.qualification_month8 = shikaku[7]  == undefined ? '' : shikaku[7].reki_tsuki
      this.inputs.qualification_body8  = shikaku[7]  == undefined ? '' : shikaku[7].reki      
      for (let i in this.user.profileSeeker_info) {
        if (this.user.profileSeeker_info[i]['sessionid'] && this.user.profileSeeker_info[i]['ckey']) {
          this.inputs.sessionid = this.user.profileSeeker_info[i]['sessionid']
          this.inputs.group = this.user.profileSeeker_info[i]['ckey']
          this.$store.dispatch("directtalk/createResume", { data: this.inputs })
        }
      }
      alert('アップロード完了しました！\n履歴書読み込みのためにリロードいたします。')
      location.reload()
    }
  }
};
</script>

<style scoped>
img {
  vertical-align: bottom;
}
.radio-container > p > input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    border: 2px solid #999;
    transition: 0.2s all linear;
    position: relative;
    top: 4px;
}
.radio-container > p > input:checked {
    border: 6px solid #69f0ae;
}
.radio-container {
    font-size: 14px;
    display: flex;
}
input:focus {
    outline:0;
}
button:focus {
    outline:0;
}
/* margin4px */
.top-space4 {
    margin-top: 4px;
}
.right-space4 {
    margin-right: 4px;
}
.bottom-space4 {
    margin-bottom: 4px;
}
.left-space4 {
    margin-left: 4px;
}
/* margin8px */
.top-space8 {
    margin-top: 8px;
}
.right-space8 {
    margin-right: 8px;
}
.bottom-space8 {
    margin-bottom: 8px;
}
.left-space8 {
    margin-left: 8px;
}
/* bulma改造 */
.select:not(.is-multiple) {
    height: auto !important;
}
.control.has-icons-left .icon, .control.has-icons-right .icon {
    height: auto !important;
    top: 36% !important;
    width: auto !important;
    padding-left: 8px;
}
.select select {
    color: #757575 !important;
}
.tag {
    font-size: 14px !important;
    border-radius: 0 !important;
    background-color: #9E9E9E !important;
    color: #fff !important;
    cursor: pointer;
}
.select:not(.is-multiple):not(.is-loading)::after {
    border-color: #C82E42 !important;
}
/* base.html */
header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #ffffff;
}
header > section {
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #9E9E9E;
}
.title-container{
    display: flex;
    color: #4a4a4a;
    margin-left: 80px;
}
.logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}
.logo-wrapper > img {
    width: 40px;
    height: auto;
}
.logo-title {
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: bold;
}
.logo-title > img {
    width: 160px;
}
.link-nav {
    position: relative;
    height: 100%;
}
.link-nav > ul {
    display: flex;
    align-items: center;
    height: 100%;
}
.link-nav  button {
    height: 100%;
    font-size: 12px;
    font-weight: bold;
    margin-left: 16px;
    padding: 8px 16px;
}
.company-link {
    text-align: right;
    color: #C82E42;
    font-size: 10px;
    position: absolute;
    bottom: 0;
    right: 0;
}
.company-link > a {
    color: #C82E42;
    font-size: 10px;
}
.login-btn {
    background-color: #C82E42;
    color: #ffffff;
    cursor: pointer;
    border: none;
}
.register-btn {
    color: #C82E42;
    border: solid 1px#F4B8C5;
    cursor: pointer;
    border-radius: 20px;
    background-color: #ffffff;
}
.footer-container {
    background: #24282A; 
    color: #ffffff;
    padding: 24px 0;
}
.footer-wrapper {
    width: 90%;
    margin: auto;
}
.footer-menu {
    display: flex;
    padding-bottom: 32px;
    margin: auto;
    justify-content: center;
    text-align: center;
}
.footer-link-wrapper {
    width: 240px;
}
.footer-link {
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    margin: 8px;
}
.footer-link:hover {
    text-decoration: underline;
}
.white_logo {
    width: 32px;
}
.white_logo_msg {
    width: 120px;
}
.company-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.company {
    font-size: 1.4rem;
    margin-left: 4px;
}
.copyright-big {
    font-size: 12px;
    margin-left: 8px;
}
.copyright {
    padding-top: 16px;
    font-size: 0.6rem;
    text-align: center;
}
#login_link {
    margin-left: 16px;
    height: 100%;
}
.header-img-icon {
    height: 56px;
    width: 56px;
    object-fit: cover;
    border-radius: 50%;
    background: white;
    border: solid 1px #9E9E9E;
    cursor: pointer;   
}
.img-icon {
    height: 56px;
    width: 56px;
    object-fit: cover;
    border-radius: 50%;
    background: white;
    border: solid 1px #9E9E9E;
}
.logedin {
    display: none;
}
.modal-box {
    background: #fff;
    padding: 16px;
    opacity: 0.9;
    font-size: 14px;
    right: 0;
    position: absolute;
    border: 1px solid #dbdbdb;
    line-height: 2;
}
.close-btn-wrapper {
    text-align: right;
}
.close-btn {
    cursor: pointer;
}
.user-info {
    display: flex;
    padding-bottom: 8px;
    border-bottom: 1px solid #9E9E9E;
}
.sub-logo-title {
    color: #1D2D5E;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: georgia;
    font-size: 22px;
    margin-left: 8px;
}
.additional-title {
    font-size: 10px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 16px;
}
.top-button-container {
    display: flex;
}
.search-link-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}
.search-link-wrapper > a {
  text-align: right;
}
.recruit-company-link-wrapper {
	position: relative;
	height: 24px;
}
.icon-search, .icon-pen {
    margin-right: 6px;
}
.icon-building {
    margin-bottom: 6px;
}
.icon-building-responsive {
    margin-right: 6px;
}
.menu-bars-wrapper {
    display: none;
    cursor: pointer;
}
.menu {
    position: fixed;
    top: 0;
    right: 8px;
    bottom: 0;
    z-index: 12;
    width: 320px;
    height: fit-content;
    top: 88px;
    background-color: #ffffff;
    overflow: hidden;
    overflow-y: auto;
    padding: 16px;
    box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.31);
    /* display: none; */
}
.menu > ul {
    font-size: 16px;
}
.menu ul > li {
    margin-top: 16px;
}
.item-login {
    width: 184px;
    padding: 8px;
    background: #C82E42;
    color: #ffffff;
    text-align: center;
    margin: auto;
    font-size: 12px;
}
.item-search, .item-register {
    width: 184px;
    padding: 8px;
    color: #C82E42;
    border: solid 1px#F4B8C5;
    border-radius: 20px;
    text-align: center;
    margin: auto;
    font-size: 12px;
}
.item-client-link {
    width: 184px;
    color: #C82E42;
    font-size: 12px;
    padding: 8px;
    margin: auto;
}
.modal-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 0%;
    background: #000000;
    opacity: 0.6;
    z-index: 11;
    /* display: none; */
}
.menu-logo-wrapper {
    width: 160px;
    margin: auto;
}
.menu-logo-title {
    width: 160px;
    margin: auto;
}
.profile-button {
    margin-right: 16px;
}
.icon-right {
    padding-left: 6px;
}
.name-and-email {
    width: 70%;
    word-wrap: break-word;
    margin-top: 4px;
}
.name-and-email > .name {
    font-weight: bold;
    font-size: 14px;
}
.name-and-email {
  text-align: left;
}
.name-and-email > .email {
    font-size: 12px;
}
.user-menu {
  text-align: left;
}
.user-menu > li > a, .logout-btn {
    font-size: 14px;
    color: #4a4a4a !important;
    cursor: pointer;
    width: fit-content;
}
.user-menu > li > a > svg,
.user-menu > li > div > svg {
    margin-right: 6px;
}
.title-wrapper {
    display: flex;
}
@media screen and (max-width: 1024px) {
    .title-container {
        margin-left: 16px;
    }
    .additional-title {
        display: none;
    }
}
@media screen and (max-width: 896px) {
    .pc-menu {
        display: none;
    }
    .menu-bars-wrapper {
        display: block;
    }
    .menu-bars {
        font-size: 24px;
        margin-right: 16px;
    }
    .footer-link {
        font-size: 12px;
    }
}
@media screen and (max-width: 480px) {
    header > section {
        height: 48px;
    }
    .logo-wrapper > img {
        width: 24px;
        height: auto;
    }
    .logo-title > img {
        width: 96px;
    }
    .menu-bars {
        font-size: 20px;
    }
    .white_logo {
        width: 32px;
    }
    .white_logo_msg {
        width: 120px;
    }
    .menu {
        top: 0;
        right: 0;
        width: 70%;
        height: 100vh;
    }
    .menu-logo-wrapper {
        width: 120px;
        margin: auto;
    }
    .menu-logo-title {
        width: 160px;
        margin: auto;
    }
    .img-icon, .header-img-icon {
        height: 32px;
        width: 32px;
    }
    .modal-cover {
        width: 100%;
        height: 100%;
    }
    .name-and-email > .name {
        font-size: 12px;
    }
    .name-and-email > .email {
        font-size: 10px;
    }
}
@media screen and (max-width: 436px) {
    .copyright-big {
        margin-top: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Recruit/RecruitNav.vue